/*
 * getUrlVars creates the window.getUrlVars function.
 *
 * window.getUrlVars returns the querystring keys and values in an array.
 */
const getUrlVars = () => {
  const vars = [];
  let hash;
  const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (let i = 0; i < hashes.length; i += 1) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1]; // eslint-disable-line prefer-destructuring
  }
  return vars;
};

export default getUrlVars;
